import { render, staticRenderFns } from "./booking-location-list-item-skeleton.vue?vue&type=template&id=1101f687&scoped=true&"
import script from "./booking-location-list-item-skeleton.vue?vue&type=script&lang=js&"
export * from "./booking-location-list-item-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./booking-location-list-item-skeleton.vue?vue&type=style&index=0&id=1101f687&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1101f687",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
